export default {"src":"/_next/static/media/level_3.835f515e.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};